import {useStyle} from "../../hooks";
import React from "react";
import {useZoomTranslate} from "./ZoomTranslate";

const FancyGrid = () => {
    let {x, y, zoom} = useZoomTranslate();

    let divBy = 8;
    let w_ = 24 * divBy;
    let w = w_ * zoom;
    let dz = 1.1;

    let color = useStyle().palette.default.main;

    let getOpacity = (x: number) => {
        if (x < .5) return 0;
        if (x > 1.5) return 1;
        return x - .5;
    }

    let opacity1 = getOpacity(w * zoom / 24 * .25) * .5;
    let opacity2 = getOpacity(w * zoom / 24 * divBy * .25);
    opacity2 = Math.max(opacity2, .667);

    let sz1 = 1; // + getOpacity(w * zoom / 24) * .333;
    let sz2 = getOpacity(w * zoom / 24 + .75) * (1.333 - getOpacity(w * zoom / 24 * .25) * .333);

    return <div style={{
        position: 'absolute',
        left: x % w - w,
        top: y % w - w,
        width: `calc(100% + ${2 * w}px)`,
        height: `calc(100% + ${2 * w}px)`,
        pointerEvents: "none",
        opacity: .667
    }}>
        <svg style={{position: 'absolute', left: 0, top: 0, width: "100%", height: "100%"}} fill={color}>
            <defs>
                <pattern id={"bg"} viewBox={"0,0,100,100"} width={w} height={w} patternUnits="userSpaceOnUse">
                    {[...Array(divBy + 1).keys()].map(i => {
                        return [...Array(divBy + 1).keys()].map(j => {
                            let on = (i % divBy === 0 && j % divBy === 0);
                            return <>
                                <circle cx={i * 100 / divBy} cy={j * 100 / divBy}
                                        r={(on ? sz2 : sz1) * dz * 100 / w_ / zoom}
                                        fillOpacity={on ? opacity2 : opacity1}/>
                                {on && <g strokeOpacity={opacity2}>
                                    <line
                                        x1={i * 100 / divBy - 2}
                                        y1={j * 100 / divBy}
                                        x2={i * 100 / divBy + 2}
                                        y2={j * 100 / divBy}
                                        stroke={color}
                                        strokeWidth={sz2 * dz * 100 / w_ / zoom}
                                    />
                                    <line
                                        x1={i * 100 / divBy}
                                        y1={j * 100 / divBy - 2}
                                        x2={i * 100 / divBy}
                                        y2={j * 100 / divBy + 2}
                                        stroke={color}
                                        strokeWidth={sz2 * dz * 100 / w_ / zoom}
                                    />
                                </g>}
                            </>
                        });
                    })}
                </pattern>
            </defs>
            <rect width="100%" height="100%" fill="url(#bg)"/>
        </svg>
    </div>
}

export default FancyGrid;